/** Normalize migrated Czech aliases only for routes owned by Angular. */
export function normalizeFrontendPath(path: string): string {
  return path.replace(/^\/cs\/(?=(?:clanek|sekce|tema|autor|stranka|fotogalerie|search|newsletter)(?:\/|[?#]|$))/, '/');
}
